import request from '@/utils/request'

// 회원 장바구니에 상품 등록
export function cartCreate(data) {
  // 장바구니 : isCart = 1 / isOrder = 0
  // 바로구매 : isCart = 0 / isOrder = 1

  // 옵션 없는 상품
  /* const data = {
    productId: 2,
    isCart: 1,
    isOrder: 0,
    cartItems: [
      {
        qty: 1
      }
    ]
  } */

  // 옵션이 있는 상품
  /* const data = {
    productId: 2479792,
    isCart: 1,
    isOrder: 0,
    cartItems: [
      {
        productOptionId: 219,
        qty: 1
      }
    ]
  } */

  // 선택형 + 입력형 옵션
  /* const data = {
    productId: 2487613,
    isCart: 1,
    isOrder: 0,
    cartItems: [
      {
        productOptionId: 228,
        qty: 1,
        textOptions: [
          {
            id: 1,
            optionValue: '입력텍스트'
          }
        ]
      }
    ]
  } */

  // 주석 삭제 예정
  return request({
    url: `/api/cart/add`,
    method: 'post',
    data
  })
}

// 회원의 장바구니 리스트를 가져온다.
export function cartList(params) {
  // params : cart(장바구니 여부), order(주문 대상 여부)
  // { cart: 1, order: 1 } (장바구니에서 넘어온 주문)
  // { cart: 0, order: 1} (바로구매에서 넘어온 주문)
  return request({
    url: `/api/cart/list`,
    method: 'get',
    params
  })
}

// 회원의 장바구니 정보를 업데이트 한다. (등록/수정/삭제 동시 진행됨)
export function cartUpdate(data) {
  return request({
    url: `/api/cart/modify`,
    method: 'post',
    data
  })
}
// 회원의 장바구니 상품 id로 삭제 한다.
export function cartClear(data) {
  const formData = new FormData()
  formData.append('ids', data)
  return request({
    url: `/api/cart/clear`,
    method: 'post',
    data: formData
  })
}
// 회원의 장바구니 정보를 전부 삭제 한다.
export function cartAllClear() {
  return request({
    url: `/api/cart/all/clear`,
    method: 'post'
  })
}

export function cartOrder(data) {
  const formData = new FormData()
  formData.append('ids', data)
  return request({
    url: `/api/cart/order`,
    method: 'post',
    data: formData
  })
}

export function cartCount() {
  return request({
    url: '/api/cart/count',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/cart.js